import { render, staticRenderFns } from "./SectionPreviewModal.vue?vue&type=template&id=8bee00e4"
import script from "./SectionPreviewModal.vue?vue&type=script&lang=js"
export * from "./SectionPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports